/*
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited 2023.
 */

import { mapOrderRowToGTMProduct } from '@/data/events/data/gtm/productAttributes';
import { GTMCheckoutPayload } from '@/data/types/GTM';

export const getGTMCheckoutPaymentEventData = async (payload: GTMCheckoutPayload) => {
	const { cart, storeName, orgName, orgId, orderItemListRows = [] } = payload;
	const { grandTotal, grandTotalCurrency } = cart;
	const hcl_account = orgId ? orgName : null;
	const marketplaceStore = storeName;

	const products = orderItemListRows.map((row) => mapOrderRowToGTMProduct(row));

	return {
		products,
		payMethods: cart.paymentInstruction,
		grandTotal: Number(grandTotal),
		grandTotalCurrency,
		marketplaceStore,
		hcl_account,
	};
};
